import React from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import withRouter from "../../custom/withRouter";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import toggleMenu from "../../../redux/SideBar/sideBarActions";
import { connect } from "react-redux";
import CommonIcon from "../../helpers/icons";
import { ToastContainer, toast } from "react-toastify";
import { FormLabel } from "react-bootstrap";
import { TextField } from "@material-ui/core";
import {
  country,
  DateFormat,
  GetGlobalSettings,
  Language,
  TimeZone,
  updateGlobalSettings,
} from "../../../action/SettingsApi";
import ImageCropper from "./Cropper";
import API from "../../helpers/endpointservice";
import Actions from "../../../action/api";
import { Autocomplete } from "@mui/material";
// import parsePhoneNumber, { parsePhoneNumberFromString } from 'libphonenumber-js';
import { parsePhoneNumberFromString } from "libphonenumber-js/max";
import Countries from "../../helpers/countries";
import { BorderLeft } from "@mui/icons-material";

class GlobalSettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isWebMobile: false, // Or get it from props if necessary: this.props.isWebMobile,
      edit: false,
      adminDetails: {},
      localizationPreferences: {},
      orgName: "",
      domainName: "",
      primaryEmail: "",
      primaryPhone: "",
      primaryPhoneCode: "",
      countryData: [],
      language: "",
      dateFormat: "",
      country: "",
      Address: "",
      timeZoneId: "",
      dateFormatId: "",
      countryId: "",
      logo: [],
      languages: [],
      countries: [],
      showCropper: false,
      currentFile: null,
      uploadedImage: null,
      tenantLogo: null,
      dateFormats: [],
      orgError: false,
      phoneError: false,
      timezones: [],
    };
  }
  componentDidMount() {
    // this.getCountries();
    this.setState({ countryData: Countries });
    const intervals = setInterval(() => {
      this.resize();
    }, 10);
    this.getTenantLogo();
    this.props.dispatch(GetGlobalSettings()).then((res) => {
      this.setState({
        adminDetails: res.adminDetails,
        localizationPreferences: res.localizationPrefereences,
      });
    });
    this.props.dispatch(Language()).then((res) => {
      console.log(res);

      this.setState({ languages: res });
    });
    this.props.dispatch(DateFormat()).then((res) => {
      console.log(res.result);

      this.setState({ dateFormats: res.result });
    });
    this.props.dispatch(country()).then((res) => {
      console.log(res.result);

      this.setState({ countries: res.result });
    });
    this.props.dispatch(TimeZone()).then((res) => {
      console.log(res.result);

      this.setState({ timezones: res.result });
    });
  }
  customToast = (message) => {
    toast(message, {
      hideProgressBar: true,
      autoClose: 2000, // Customize time as per your requirement
      closeOnClick: false,
      pauseOnHover: false,
      draggable: false,
      position: "top-right",
      className: "custom-toast", // Add a custom class here
    });
  };

  getTenantLogo = async () => {
    Actions.GET(API.UploadLogo)
      .then((res) => {
        if (res.data) {
          this.setState({ tenantLogo: res.data });
          let file = this.base64ToFile(res.data.fileName, res.data.fileBytes);
          if (file) {
            this.setState({ uploadedImage: file });
            this.uploadFileLogo(file);
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  uploadFileLogo = async (file) => {
    let upload = {
      fileName: file.name,
      FileSize: file.size,
      fdata: file,
      fileBytes: await this.toBase64(file),
    };
    let array = [];
    array.push(upload);
    this.setState({ logo: array });
  };

  handleChange = (event, newValue) => {
    this.setState({ value: newValue });
  };
  resize = () => {
    if (window.innerWidth < 850) {
      this.setState({
        isMobile: true,
      });
    } else {
      this.setState({
        isMobile: false,
        isWebMobile: false,
      });
    }

    if (window.innerWidth < 468) {
      this.setState({
        isMobile600: true,
        isWebMobile: true,
      });
    } else {
      this.setState({
        isMobile600: false,
        isWebMobile: false,
      });
    }

    if (window.innerWidth < 380) {
      this.setState({
        isMobile380: true,
      });
      this.setState({
        isMobile380: true,
      });
    } else {
      this.setState({
        isMobile380: false,
      });
    }
    this.setState({
      height: window.innerHeight,
    });
  };
  edit = () => {
    const fullPhone = this.state.adminDetails.adminPhoneNumber || "";
    this.setState({ phoneError: "", orgError: "" });
    let primaryPhoneCod = "";
    let primaryPhone = "";
    if (fullPhone.includes("-")) {
      [primaryPhoneCod, primaryPhone] = fullPhone.split("-");
    } else if (fullPhone.startsWith("+")) {
      primaryPhoneCod = fullPhone;
    } else {
      primaryPhone = fullPhone;
    }
    this.setState({
      domainName: this.state.adminDetails.domain,
      orgName: this.state.adminDetails.organizationName,
      primaryEmail: this.state.adminDetails.adminEmail,
      primaryPhone: primaryPhone,
      primaryPhoneCode: primaryPhoneCod,
      language: this.state.localizationPreferences.languageId,
      countryId: this.state.localizationPreferences.countryId,
      Address: this.state.localizationPreferences.addressDetails,
      timeZoneId: this.state.localizationPreferences.timeZone,
      dateFormat: this.state.localizationPreferences?.dateFormatId,
    });
    console.log(primaryPhone, primaryPhoneCod);
    this.setState({ edit: true });
  };

  validatePhoneNumberByDialCode = (countryCode, phoneNumber) => {
    try {
      const fullNumber = `${countryCode}${phoneNumber}`;
      const phone = parsePhoneNumberFromString(fullNumber);
      return phone && phone.isValid();
    } catch (error) {
      console.error("Validation failed:", error.message);
      return false;
    }
  };

  handleValidation = () => {
    let error = false;

    if (this.state.orgName.trim() === "") {
      error = true;
      this.setState({ orgError: "Organization name is mandatory" });
    } else {
      this.setState({ orgError: "" });
    }

    if (
      (this.state.primaryPhoneCode !== "" &&
        this.state.primaryPhoneCode !== null) ||
      this.state.primaryPhone !== ""
    ) {
      if (
        ((this.state.primaryPhoneCode !== "" ||
          this.state.primaryPhoneCode !== null) &&
          this.state.primaryPhone == "") ||
        ((this.state.primaryPhoneCode == "" ||
          this.state.primaryPhoneCode == null) &&
          this.state.primaryPhone !== "")
      ) {
        if (
          this.state.primaryPhoneCode !== "" &&
          this.state.primaryPhoneCode !== null &&
          this.state.primaryPhone == ""
        ) {
          error = true;
          this.setState({ phoneError: "Phone number is missing" });
        } else if (
          (this.state.primaryPhoneCode == "" ||
            this.state.primaryPhoneCode == null) &&
          this.state.primaryPhone !== ""
        ) {
          error = true;
          this.setState({ phoneError: "Country code is missing" });
        }
      } else {
        this.setState({ phoneError: "Country code is missing" });
      }

      if (
        this.state.primaryPhoneCode !== "" &&
        this.state.primaryPhoneCode !== null &&
        this.state.primaryPhone !== ""
      ) {
        let bool = this.validatePhoneNumberByDialCode(
          this.state.primaryPhoneCode,
          this.state.primaryPhone
        );
        if (!bool) {
          error = true;
          this.setState({ phoneError: "Invalid phone number" });
          // this.state.errorPhoneNo = true;
          // if (!focusErrorField) {
          //     focusErrorField = this.phNoRef.current;
          // }
        } else {
          this.setState({ phoneError: "" });
        }
      }
    } else {
      this.setState({ phoneError: "" });
    }

    return error;
  };

  update = () => {
    if (!this.handleValidation()) {
      let data = {
        adminDetails: {
          organizationName: this.state.orgName,

          adminEmail: this.state.primaryEmail,

          adminPhoneNumber:
            this.state.primaryPhoneCode + "-" + this.state.primaryPhone,

          domain: this.state.domainName ?? "",
        },

        localizationPrefereences: {
          languageId: this.state.language,

          dateFormat: this.state.dateFormat ?? null,

          countryId: this.state.countryId ?? null,

          timeZone: this.state.timeZoneId,

          addressDetails: this.state.Address,
        },
      };

      this.props
        .dispatch(updateGlobalSettings(data))
        .then((res) => {
          this.uploadLogo();
          this.customToast("Global settings updated");
          this.props
            .dispatch(GetGlobalSettings())
            .then((res) => {
              this.setState({
                adminDetails: res.adminDetails,
                localizationPreferences: res.localizationPrefereences,
              });
              this.setState({ edit: false });
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch((error) => {
          this.customToast("Error updating global settings");
          console.log(error);
        });
    }
  };
  cancel = () => {
    this.setState({ edit: false });
    if (this.state.tenantLogo?.fileBytes) {
      let file = this.base64ToFile(
        this.state.tenantLogo.fileName,
        this.state.tenantLogo.fileBytes
      );
      if (file) {
        this.setState({ uploadedImage: file });
        this.uploadFileLogo(file);
      }
    }
  };

  onCrop = async (file) => {
    debugger;
    this.setState({ uploadedImage: file });
    let upload = {
      fileName: file.name,
      FileSize: file.size,
      fdata: file,
      fileBytes: await this.toBase64(file),
    };
    let array = [];
    array.push(upload);
    this.setState({ logo: array });
  };

  handleFileChange = (event) => {
    this.props.dispatch({ type: "CONFIRMATION_POPUP", data: true });
    this.setState({ currentFile: event.target.files[0] }, () => {
      this.setState({ showCropper: true });
      event.target.value = null;
    });
  };
  toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  deleteFile = (fileIndex) => {
    this.props.dispatch({ type: "CONFIRMATION_POPUP", data: true });
    this.state.deleteLogo = true;
    this.setState({ uploadedImage: null, currentFile: null, logo: [] });
    this.setState({});
    // this.setState((prevState) => ({
    //     ...prevState.logo,
    //     logo: prevState.logo.filter((_, index) => index !== fileIndex),
    // }));
  };

  uploadLogo = () => {
    if (this.state.uploadedImage) {
      const formData = new FormData();
      formData.append("file", this.state.uploadedImage);
      Actions.PUT(API.UploadLogo, formData)
        .then((res) => {
          // this.setState({ edit: false });
          this.getTenantLogo();
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      Actions.DELETE(API.UploadLogo)
        .then((res) => {
          // this.setState({ edit: false });
          this.getTenantLogo();
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  getImageSrcFromBase64 = (fileName, fileBytes) => {
    if (!fileName || !fileBytes) return null;

    const extension = fileName.split(".").pop().toLowerCase();

    const mimeTypes = {
      jpg: "image/jpeg",
      jpeg: "image/jpeg",
      png: "image/png",
      gif: "image/gif",
      bmp: "image/bmp",
      webp: "image/webp",
      svg: "image/svg+xml",
    };

    const mimeType = mimeTypes[extension] || "application/octet-stream";

    return `data:${mimeType};base64,${fileBytes}`;
  };

  getCountries = () => {
    Actions.GET(API.GET_COUNTRIES)
      .then((res) => {
        if (res.data) {
          const filteredData = res.data
            .filter(
              (item) => item.countryCode && item.countryCode.trim() !== ""
            )
            .map((item) => ({
              ...item,
              // optionally do more transformation here
            }));
          this.setState({ countryData: filteredData });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  base64ToFile = (fileName, base64Data) => {
    const extension = fileName.split(".").pop().toLowerCase();

    const mimeTypes = {
      jpg: "image/jpeg",
      jpeg: "image/jpeg",
      png: "image/png",
      gif: "image/gif",
      bmp: "image/bmp",
      webp: "image/webp",
      svg: "image/svg+xml",
    };

    const mimeType = mimeTypes[extension] || "application/octet-stream";

    const byteString = atob(base64Data); // decode base64
    const byteArray = new Uint8Array(byteString.length);

    for (let i = 0; i < byteString.length; i++) {
      byteArray[i] = byteString.charCodeAt(i);
    }

    return new File([byteArray], fileName, { type: mimeType });
  };

  render() {
    const { isWebMobile } = this.state;
    return (
      <>
        <ToastContainer position="top-right" />
        {!isWebMobile ? (
          <div className="mainglobalSetting">
            {/* API INTEGRATION  */}
            <div className="row w-100">
              <div className="col-12 ps-0 ">
                <div className="row ps-3 mt-2">
                  <div className="col-12 col-md-12 col-sm-12 col-lg-4 col-xl-3 col-xxl-2">
                    <h3 className="licenseheader">Administration Details</h3>
                  </div>
                  <div className="col-12 col-md-12 col-sm-12 col-lg-8 col-xl-9 col-xxl-10 pt-0">
                    <div>
                      <div className="col-12 col-lg-9 col-md-8 ps-0">
                        <label className="formlabel-style1 d-block">
                          Organization name
                        </label>
                        {!this.state.edit ? (
                          <span className="formlabel-input">
                            {this.state.adminDetails.organizationName}
                          </span>
                        ) : (
                          <TextField
                            fullWidth
                            inputProps={{ maxLength: 255 }}
                            error={this.state.orgError}
                            helperText={
                              this.state.orgError ? this.state.orgError : ""
                            }
                            className="filter_input1"
                            variant="filled"
                            size="small"
                            value={this.state.orgName}
                            onChange={(e) =>
                              this.setState({ orgName: e.target.value })
                            }
                          />
                        )}
                      </div>

                      <div className="col-12 col-lg-9 col-md-8 ps-0 ps-0 mt-2">
                        <label className="formlabel-style1 d-block">
                          Domain name
                        </label>
                        {!this.state.edit ? (
                          <span className="formlabel-input">
                            {this.state.adminDetails.domain}
                          </span>
                        ) : (
                          <TextField
                            fullWidth
                            disabled
                            className="filter_input1"
                            variant="filled"
                            size="small"
                            value={this.state.domainName}
                            onChange={(e) =>
                              this.setState({ domainName: e.target.value })
                            }
                          />
                        )}
                      </div>
                    </div>

                    <div className="col-12  ps-0 mt-2">
                      <div className="col-12 col-lg-9 col-md-8 ps-0">
                        <label className="formlabel-style1 d-block">
                          Primary admin email address
                        </label>
                        {!this.state.edit ? (
                          <span className="formlabel-input">
                            {this.state.adminDetails.adminEmail}
                          </span>
                        ) : (
                          <TextField
                            fullWidth
                            disabled
                            className="filter_input1"
                            variant="filled"
                            size="small"
                            value={this.state.primaryEmail}
                            onChange={(e) =>
                              this.setState({ primaryEmail: e.target.value })
                            }
                          />
                        )}
                      </div>

                      <div className="col-12 col-lg-9 col-md-8 ps-0 mt-2">
                        <label className="formlabel-style1 d-block">
                          Primary admin phone number
                        </label>
                        {!this.state.edit ? (
                          <span className="formlabel-input">
                            {this.state.adminDetails.adminPhoneNumber}
                          </span>
                        ) : (
                          <>
                            <div className="d-flex w-100">
                              <Autocomplete
                                options={this.state.countryData}
                                getOptionLabel={(option) =>
                                  option.countryCode || ""
                                }
                                value={
                                  this.state.countryData.find(
                                    (item) =>
                                      item.countryCode ==
                                      this.state.primaryPhoneCode
                                  ) || null
                                }
                                onChange={(e, newValue) => {
                                  this.setState({
                                    primaryPhoneCode: newValue?.countryCode
                                      ? newValue.countryCode
                                      : "",
                                  });
                                }}
                                renderOption={(props, option) => {
                                  const { key, ...optionProps } = props;
                                  return (
                                    <Box
                                      key={option.id}
                                      component="li"
                                      sx={{
                                        "& > img": { mr: 1.5, flexShrink: 0 },
                                      }}
                                      {...optionProps}
                                    >
                                      <img
                                        loading="lazy"
                                        width="24"
                                        height="18"
                                        srcSet={`https://flagcdn.com/48x36/${option.code.toLowerCase()}.png 2x`}
                                        src={`https://flagcdn.com/24x18/${option.code.toLowerCase()}.png`}
                                        alt=""
                                      />
                                      {option.countryCode}
                                    </Box>
                                  );
                                }}
                                filterOptions={(options, state) => {
                                  const input = state.inputValue
                                    .replace("+", "")
                                    .trim()
                                    .toLowerCase();
                                  console.log(input, "filter check");

                                  return options.filter((option) => {
                                    const code =
                                      option.countryCode
                                        ?.replace("+", "")
                                        .toLowerCase() || "";
                                    const name =
                                      option.countryName?.toLowerCase() || "";

                                    // ✅ Match either country code or country name
                                    return (
                                      code.includes(input) ||
                                      name.includes(input)
                                    );
                                  });
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    variant="filled"
                                    error={this.state.phoneError}
                                    className="filter_input1" // or "outlined" if needed
                                    InputProps={{
                                      ...params.InputProps,
                                      disableUnderline: true,
                                      // removes underline
                                    }}
                                  />
                                )}
                                sx={{
                                  width: 150,
                                  "& .MuiInputBase-root": {
                                    borderRight: "none !important",
                                    outline: "none",
                                    padding: "6px",
                                    paddingLeft: "12px",
                                    fontSize: "13px",
                                  },
                                }}
                              />
                              <TextField
                                fullWidth
                                error={this.state.phoneError}
                                className="filter_input1"
                                variant="filled"
                                size="small"
                                value={this.state.primaryPhone}
                                onChange={(e) => {
                                  const numericValue = e.target.value.replace(
                                    /[^0-9]/g,
                                    ""
                                  );
                                  this.setState({ primaryPhone: numericValue });
                                }}
                                sx={{
                                  "& .MuiFilledInput-root": {
                                    borderLeft: "none !important",
                                    borderTopLeftRadius: 0,
                                    borderBottomLeftRadius: 0,
                                  },
                                }}
                              />
                            </div>
                            {this.state.phoneError && (
                              <span className="errorMessage">
                                {this.state.phoneError}
                              </span>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                  <hr className="hrproducts mt-2" />
                </div>
                <div className="row ps-3">
                  <div className="col-12 col-md-12 col-sm-12 col-lg-4 col-xl-3 col-xxl-2">
                    <h3 className="licenseheader">Localization Preferences</h3>
                  </div>
                  <div className="col-12 col-md-12 col-sm-12 col-lg-8 col-xl-9 col-xxl-10 pt-0">
                    <div className="col-12 ">
                      <div className="col-12 col-lg-9 col-md-8">
                        <label className="formlabel-style1 d-block">
                          Language
                        </label>
                        {/* {!this.state.edit && <span className={`formlabel-input`}>{this.state.localizationPreferences.language}</span>}
                                                {this.state.edit && <input type='text' className='w-75 inputglobal' value={this.state.localizationPreferences.language} />} */}
                        {this.state.edit && (
                          // <select className='w-75 p-2 inputglobal ' onChange={(e) => this.setState({ language: e.target.value })}>
                          //     {this.state.languages.map((e) => {
                          //         return <option value={e.id}>{e.languageName}</option>
                          //     })}
                          // </select>
                          <Autocomplete
                            disablePortal
                            className="filter_input1"
                            options={this.state.languages}
                            getOptionLabel={(option) =>
                              option.languageName || ""
                            }
                            value={
                              this.state.languages.find(
                                (l) => l.id === this.state.language
                              ) || null
                            }
                            onChange={(event, newValue) => {
                              this.setState({ language: newValue?.id || "" });
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant="filled"
                                size="small"
                                className=" filter_input1"
                              />
                            )}
                          />
                        )}
                        {!this.state.edit && (
                          <span className={`formlabel-input`}>
                            {this.state.localizationPreferences.language}
                          </span>
                        )}
                      </div>

                      <div className="col-12 col-lg-9 col-md-8 ps-0 mt-2">
                        <label className="formlabel-style1 d-block">
                          Date Format
                        </label>
                        {!this.state.edit && (
                          <span className={`formlabel-input`}>
                            {this.state.localizationPreferences.dateFormat}
                          </span>
                        )}
                        {/* {this.state.edit && <input type='text' className='w-75 inputglobal p-2' value={this.state.localizationPreferences.dateFormat} />} */}
                        {this.state.edit && (
                          // <select className='w-75 p-2 inputglobal' value={this.state.dateFormat} onChange={(e) => this.setState({ dateFormat: e.target.value })}>
                          //     {this.state.dateFormats.map((e) => {
                          //         return <option value={e.id}>{e.dateFormat}</option>
                          //     })}
                          // </select>
                          <Autocomplete
                            disablePortal
                            options={this.state.dateFormats}
                            className=" filter_input1"
                            getOptionLabel={(option) => option.dateFormat || ""}
                            value={
                              this.state.dateFormats.find(
                                (d) => d.id === this.state.dateFormat
                              ) || null
                            }
                            onChange={(event, newValue) => {
                              this.setState({ dateFormat: newValue?.id || "" });
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant="filled"
                                size="small"
                                className=" filter_input1"
                              />
                            )}
                          />
                        )}
                      </div>
                      <div className="col-12 col-lg-9 col-md-8 mt-2">
                        <label className="formlabel-style1 d-block">
                          Time zone
                        </label>
                        {/* {!this.state.edit && <span className={`formlabel-input`}>{this.state.localizationPreferences.language}</span>}
                                                {this.state.edit && <input type='text' className='w-75 inputglobal' value={this.state.localizationPreferences.language} />} */}
                        {this.state.edit && (
                          // <select className='w-75 p-2 inputglobal' value={this.state.timeZoneId} onChange={(e) => this.setState({ timeZoneId: e.target.value })}>
                          //     {this.state.timezones.map((e) => {
                          //         return <option value={e.timeZone}>{e.timeZone}</option>
                          //     })}
                          // </select>
                          <Autocomplete
                            disablePortal
                            className=" filter_input1 "
                            options={this.state.timezones}
                            getOptionLabel={(option) => option.timeZone || ""}
                            value={
                              this.state.timezones.find(
                                (t) => t.timeZone === this.state.timeZoneId
                              ) || null
                            }
                            onChange={(event, newValue) => {
                              this.setState({
                                timeZoneId: newValue?.timeZone || "",
                              });
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant="filled"
                                size="small"
                                className=" filter_input1 "
                              />
                            )}
                          />
                        )}
                        {!this.state.edit && (
                          <span className={`formlabel-input`}>
                            {this.state.localizationPreferences.timeZone}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-12 mt-2">
                      <div className="col-12 col-lg-9 col-md-8 ps-0">
                        <label className="formlabel-style1 d-block">
                          Country
                        </label>

                        {this.state.edit && (
                          // <select className='w-75 h-25 p-2 inputglobal' value={this.state.countryId || this.state.localizationPreferences.countryId} onChange={(e) => this.setState({ countryId: e.target.value })}>
                          //     {this.state.countries.map((e) => {
                          //         return <option value={e.id}>{e.name}</option>
                          //     })}
                          // </select>
                          <Autocomplete
                            disablePortal
                            className="filter_input1"
                            options={this.state.countries}
                            getOptionLabel={(option) => option.name || ""}
                            value={
                              this.state.countries.find(
                                (c) =>
                                  c.id ===
                                  (this.state.countryId ||
                                    this.state.localizationPreferences
                                      .countryId)
                              ) || null
                            }
                            onChange={(event, newValue) => {
                              this.setState({ countryId: newValue?.id || "" });
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant="filled"
                                size="small"
                                className="filter_input1"
                              />
                            )}
                          />
                        )}
                        {!this.state.edit && (
                          <span className={`formlabel-input`}>
                            {this.state.localizationPreferences.countryName}
                          </span>
                        )}
                        {/* {this.state.edit && <input type='text' className='w-75 inputglobal' />} */}
                      </div>
                      <div className="col-12 col-lg-9 col-md-8 ps-0 mt-2 pb-3">
                        <label className="formlabel-style1 d-block">
                          Address
                        </label>
                        {!this.state.edit && (
                          <span className={`formlabel-input`}>
                            {this.state.localizationPreferences.addressDetails}
                          </span>
                        )}
                        {this.state.edit && (
                          <TextField
                            value={this.state.Address}
                            // value={this.state.Address || this.state.localizationPreferences.addressDetails}
                            multiline
                            fullWidth
                            rows={4}
                            variant="outlined"
                            style={{
                              outline: "none",
                              border: "1px solid #d1d1d1;",
                              borderRadius: "0px",
                              fontSize: "13px",
                              color: "#342E37",
                            }}
                            className="mt-2 inputglobal"
                            inputProps={{ maxLength: 255 }}
                            InputProps={{
                              style: {
                                borderRadius: 0, // Sharp edges
                                // Custom border
                                fontSize: "13px",
                                color: "#342E37",
                                outline: "none",
                              },
                              disableUnderline: true,
                            }}
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                "& fieldset": {
                                  borderColor: "#d1d1d1",
                                },
                                "&:hover fieldset": {
                                  borderColor: "#d1d1d1",
                                },
                                "&.Mui-focused fieldset": {
                                  borderColor: "#d1d1d1",
                                  boxShadow: "none",
                                },
                              },
                            }}
                            onChange={(e) =>
                              this.setState({ Address: e.target.value })
                            }
                          />
                        )}
                      </div>
                    </div>
                  </div>
                  <hr className="hrproducts mt-2" />
                </div>
                <div className="row ps-3 mt-2">
                  <div className="col-12 col-md-12 col-sm-12 col-lg-4 col-xl-3 col-xxl-2">
                    <h3 className="licenseheader">Company logo</h3>
                  </div>
                  {!this.state.edit && (
                    <div className="col-12 col-md-12 col-sm-12 col-lg-8 col-xl-9 col-xxl-10 pt-0 mb-3">
                      {this.state.tenantLogo?.fileBytes ? (
                        <img
                          src={this.getImageSrcFromBase64(
                            this.state.tenantLogo.fileName,
                            this.state.tenantLogo.fileBytes
                          )}
                          width={"400px"}
                          height={"auto"}
                        />
                      ) : (
                        <span className="formlabel-input">
                          No logo has been uploaded
                        </span>
                      )}
                    </div>
                  )}
                  {this.state.edit && (
                    <div className="col-12 col-md-12 col-sm-12 col-lg-8 col-xl-9 col-xxl-10 pt-0 mb-3">
                      <div className="row">
                        <div
                          className={`col-12 col-sm-12 col-lg-4 col-xl-4 col-md-4`}
                        >
                          <span className="">
                            <div class="Profile-upload">
                              <label for="file-input" className="menu-button">
                                {this.state.uploadedImage ? (
                                  // <CommonIcon fileName={'UploadFile'} />
                                  <>
                                    <img
                                      src={URL.createObjectURL(
                                        this.state.uploadedImage
                                      )}
                                      alt="Cropped"
                                      width={"400px"}
                                      height={"auto"}
                                    />
                                  </>
                                ) : (
                                  <CommonIcon fileName={"SelectUploadFile1"} />
                                )}
                              </label>
                              <input
                                id="file-input"
                                type="file"
                                accept=".jpg, .jpeg, .png"
                                onChange={this.handleFileChange}
                                disabled={
                                  this.state.uploadedImage ? true : false
                                }
                              />
                            </div>
                            {/* {this.state.errorProfiles &&
                                        <div>
                                            <span className="errorText">
                                                Please upload the file.
                                            </span>
                                        </div>
                                    } */}
                            {this.state.logo.map((file, index) => (
                              <div className="mt-2">
                                {/* <img src={file.fileBytes && file.fileBytes.startsWith('data:image') ? file.fileBytes : `data:image/jpeg;base64,${file.fileBytes || ''}`} className="clientLogo" alt="Image" /> */}
                                <span className="file-name-style" key={index}>
                                  {" "}
                                  {file.fileName}
                                  <span onClick={() => this.deleteFile(index)}>
                                    <CommonIcon
                                      fileName={"CloseSmall"}
                                      className="cursor-pointer"
                                    />{" "}
                                  </span>
                                </span>
                              </div>
                            ))}
                          </span>
                        </div>
                      </div>
                    </div>
                  )}
                  <hr className="hrproducts mt-2" />
                </div>
                <div className="row ps-3 mt-2">
                  <div className="col-0 col-md-0 col-lg-4 col-xl-3 col-xxl-2"></div>
                  <div className="col-8 col-xl-9 col-lg-8 col-xxl-10  pt-0">
                    <div className="col-12 d-flex align-items-start">
                      <div className="col-6 ps-0">
                        {!this.state.edit && (
                          <button
                            className="btn-fun ps-4 pe-4 fs-7"
                            onClick={this.edit}
                          >
                            Edit
                          </button>
                        )}
                        {this.state.edit && (
                          <button
                            className="btn-fun ps-4 pe-4 fs-7"
                            onClick={this.update}
                          >
                            Update
                          </button>
                        )}
                        {this.state.edit && (
                          <button
                            className="btn-cancel btn-filter-action border-none ps-0 ms-0"
                            onClick={this.cancel}
                          >
                            Cancel
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* dgh */}
          </div>
        ) : (
          <div className="mobilemain ">
            {" "}
            {/* This should handle the mobile version if needed */}
            {/* Mobile version content */}
            <div className="row">
              {/* <ToastContainer className='toast-container' /> */}
              {/* <div className="col-12 titlebar-mob"> */}
              <div className="row w-100">
                <div className="col-12 ps-3 mobileglobaloverflow ">
                  <div className="row ps-3 mt-2">
                    <div className="col-12 col-md-12 col-sm-12 col-lg-4">
                      <h3 className="licenseheader">Administration Details</h3>
                    </div>
                    <div className="col-12 col-md-12 col-sm-12 col-lg-8 pt-0">
                      <div className="">
                        <div className="col-12 ">
                          <label className="formlabel-style1 d-block">
                            Organization name
                          </label>
                          {!this.state.edit ? (
                            <span className="formlabel-input">
                              {this.state.adminDetails.organizationName}
                            </span>
                          ) : (
                            <TextField
                              fullWidth
                              inputProps={{ maxLength: 255 }}
                              error={this.state.orgError}
                              helperText={
                                this.state.orgError ? this.state.orgError : ""
                              }
                              className="filter_input1"
                              variant="filled"
                              size="small"
                              value={this.state.orgName}
                              onChange={(e) =>
                                this.setState({ orgName: e.target.value })
                              }
                            />
                          )}
                        </div>
                        <div className="col-12 ps-0 mt-2">
                          <label className="formlabel-style1 d-block">
                            Domain name
                          </label>
                          {!this.state.edit ? (
                            <span className="formlabel-input">
                              {this.state.adminDetails.domain}
                            </span>
                          ) : (
                            <TextField
                              fullWidth
                              disabled
                              className="filter_input1"
                              variant="filled"
                              size="small"
                              value={this.state.domainName}
                              onChange={(e) =>
                                this.setState({ domainName: e.target.value })
                              }
                            />
                          )}
                        </div>
                      </div>
                      <div className="col-12 mt-2">
                        <div className="col-12 ps-0">
                          <label className="formlabel-style1 d-block">
                            Primary admin email address
                          </label>
                          {!this.state.edit ? (
                            <span className="formlabel-input">
                              {this.state.adminDetails.adminEmail}
                            </span>
                          ) : (
                            <TextField
                              fullWidth
                              disabled
                              className="filter_input1"
                              variant="filled"
                              size="small"
                              value={this.state.primaryEmail}
                              onChange={(e) =>
                                this.setState({ primaryEmail: e.target.value })
                              }
                            />
                          )}
                        </div>
                        <div className="col-12 ps-0 mt-2 ">
                          <label className="formlabel-style1 d-block">
                            Primary admin phone number
                          </label>
                          {!this.state.edit ? (
                            <span className="formlabel-input">
                              {this.state.adminDetails.adminPhoneNumber}
                            </span>
                          ) : (
                            <>
                              <div className="d-flex w-100">
                                <Autocomplete
                                  options={this.state.countryData}
                                  getOptionLabel={(option) =>
                                    option.countryCode || ""
                                  }
                                  value={
                                    this.state.countryData.find(
                                      (item) =>
                                        item.countryCode ==
                                        this.state.primaryPhoneCode
                                    ) || null
                                  }
                                  onChange={(e, newValue) => {
                                    this.setState({
                                      primaryPhoneCode: newValue?.countryCode
                                        ? newValue.countryCode
                                        : "",
                                    });
                                  }}
                                  // renderOption={(
                                  //   props,
                                  //   option,
                                  //   { selected }
                                  // ) => (
                                  //   <li {...props} key={option.id}>
                                  //     {option.countryCode}
                                  //   </li>
                                  // )}
                                  renderOption={(props, option) => {
                                    const { key, ...optionProps } = props;
                                    return (
                                      <Box
                                        key={option.id}
                                        component="li"
                                        sx={{
                                          "& > img": { mr: 1.5, flexShrink: 0 },
                                        }}
                                        {...optionProps}
                                      >
                                        <img
                                          loading="lazy"
                                          width="24"
                                          height="18"
                                          srcSet={`https://flagcdn.com/48x36/${option.code.toLowerCase()}.png 2x`}
                                          src={`https://flagcdn.com/24x18/${option.code.toLowerCase()}.png`}
                                          alt=""
                                        />
                                        {option.countryCode}
                                      </Box>
                                    );
                                  }}
                                  filterOptions={(options, state) => {
                                    const input = state.inputValue
                                      .replace("+", "")
                                      .trim()
                                      .toLowerCase();
                                    console.log(input, "filter check");

                                    return options.filter((option) => {
                                      const code =
                                        option.countryCode
                                          ?.replace("+", "")
                                          .toLowerCase() || "";
                                      const name =
                                        option.countryName?.toLowerCase() || "";

                                      // ✅ Match either country code or country name
                                      return (
                                        code.includes(input) ||
                                        name.includes(input)
                                      );
                                    });
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      variant="filled"
                                      error={this.state.phoneError}
                                      className="filter_input1" // or "outlined" if needed
                                      InputProps={{
                                        ...params.InputProps,
                                        disableUnderline: true,
                                        // removes underline
                                      }}
                                    />
                                  )}
                                  sx={{
                                    width: 150,
                                    "& .MuiInputBase-root": {
                                      borderRight: "none !important",
                                      outline: "none",
                                      padding: "6px",
                                      paddingLeft: "12px",
                                      fontSize: "13px",
                                    },
                                  }}
                                />
                                <TextField
                                  fullWidth
                                  error={this.state.phoneError}
                                  className="filter_input1"
                                  variant="filled"
                                  size="small"
                                  value={this.state.primaryPhone}
                                  onChange={(e) => {
                                    const numericValue = e.target.value.replace(
                                      /[^0-9]/g,
                                      ""
                                    );
                                    this.setState({
                                      primaryPhone: numericValue,
                                    });
                                  }}
                                  sx={{
                                    "& .MuiFilledInput-root": {
                                      borderLeft: "none !important",
                                      borderTopLeftRadius: 0,
                                      borderBottomLeftRadius: 0,
                                    },
                                  }}
                                />
                              </div>
                              {this.state.phoneError && (
                                <span className="errorMessage">
                                  {this.state.phoneError}
                                </span>
                              )}
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                    <hr className="hrproducts mt-2" />
                  </div>
                  <div className="row ps-3">
                    <div className="col-12 col-md-12 col-sm-12 col-lg-4">
                      <h3 className="licenseheader">
                        Localization Preferences
                      </h3>
                    </div>
                    <div className="col-12 col-md-12 col-sm-12 col-lg-8 pt-0">
                      <div className="col-12 ">
                        <div className="col-12">
                          <label className="formlabel-style1 d-block">
                            Language
                          </label>
                          {/* {!this.state.edit && <span className={`formlabel-input`}>{this.state.localizationPreferences.language}</span>}
                                                {this.state.edit && <input type='text' className='w-75 inputglobal' value={this.state.localizationPreferences.language} />} */}
                          {this.state.edit && (
                            // <select className='w-75 p-2 inputglobal ' onChange={(e) => this.setState({ language: e.target.value })}>
                            //     {this.state.languages.map((e) => {
                            //         return <option value={e.id}>{e.languageName}</option>
                            //     })}
                            // </select>
                            <Autocomplete
                              disablePortal
                              className="filter_input1"
                              options={this.state.languages}
                              getOptionLabel={(option) =>
                                option.languageName || ""
                              }
                              value={
                                this.state.languages.find(
                                  (l) => l.id === this.state.language
                                ) || null
                              }
                              onChange={(event, newValue) => {
                                this.setState({ language: newValue?.id || "" });
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  variant="filled"
                                  size="small"
                                  className=" filter_input1"
                                />
                              )}
                            />
                          )}
                          {!this.state.edit && (
                            <span className={`formlabel-input`}>
                              {this.state.localizationPreferences.language}
                            </span>
                          )}
                        </div>

                        <div className="col-12 ps-0 mt-2">
                          <label className="formlabel-style1 d-block">
                            Date Format
                          </label>
                          {!this.state.edit && (
                            <span className={`formlabel-input`}>
                              {this.state.localizationPreferences.dateFormat}
                            </span>
                          )}
                          {/* {this.state.edit && <input type='text' className='w-75 inputglobal p-2' value={this.state.localizationPreferences.dateFormat} />} */}
                          {this.state.edit && (
                            // <select className='w-75 p-2 inputglobal' value={this.state.dateFormat} onChange={(e) => this.setState({ dateFormat: e.target.value })}>
                            //     {this.state.dateFormats.map((e) => {
                            //         return <option value={e.id}>{e.dateFormat}</option>
                            //     })}
                            // </select>
                            <Autocomplete
                              disablePortal
                              options={this.state.dateFormats}
                              className=" filter_input1"
                              getOptionLabel={(option) =>
                                option.dateFormat || ""
                              }
                              value={
                                this.state.dateFormats.find(
                                  (d) => d.id === this.state.dateFormat
                                ) || null
                              }
                              onChange={(event, newValue) => {
                                this.setState({
                                  dateFormat: newValue?.id || "",
                                });
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  variant="filled"
                                  size="small"
                                  className=" filter_input1"
                                />
                              )}
                            />
                          )}
                        </div>
                        <div className="col-12 mt-2">
                          <label className="formlabel-style1 d-block">
                            Time zone
                          </label>
                          {/* {!this.state.edit && <span className={`formlabel-input`}>{this.state.localizationPreferences.language}</span>}
                                                {this.state.edit && <input type='text' className='w-75 inputglobal' value={this.state.localizationPreferences.language} />} */}
                          {this.state.edit && (
                            // <select className='w-75 p-2 inputglobal' value={this.state.timeZoneId} onChange={(e) => this.setState({ timeZoneId: e.target.value })}>
                            //     {this.state.timezones.map((e) => {
                            //         return <option value={e.timeZone}>{e.timeZone}</option>
                            //     })}
                            // </select>
                            <Autocomplete
                              disablePortal
                              className=" filter_input1 "
                              options={this.state.timezones}
                              getOptionLabel={(option) => option.timeZone || ""}
                              value={
                                this.state.timezones.find(
                                  (t) => t.timeZone === this.state.timeZoneId
                                ) || null
                              }
                              onChange={(event, newValue) => {
                                this.setState({
                                  timeZoneId: newValue?.timeZone || "",
                                });
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  variant="filled"
                                  size="small"
                                  className=" filter_input1 "
                                />
                              )}
                            />
                          )}
                          {!this.state.edit && (
                            <span className={`formlabel-input`}>
                              {this.state.localizationPreferences.timeZone}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-12 mt-2">
                        <div className="col-12 ps-0">
                          <label className="formlabel-style1 d-block">
                            Country
                          </label>

                          {this.state.edit && (
                            // <select className='w-75 h-25 p-2 inputglobal' value={this.state.countryId || this.state.localizationPreferences.countryId} onChange={(e) => this.setState({ countryId: e.target.value })}>
                            //     {this.state.countries.map((e) => {
                            //         return <option value={e.id}>{e.name}</option>
                            //     })}
                            // </select>
                            <Autocomplete
                              disablePortal
                              className="filter_input1"
                              options={this.state.countries}
                              getOptionLabel={(option) => option.name || ""}
                              value={
                                this.state.countries.find(
                                  (c) =>
                                    c.id ===
                                    (this.state.countryId ||
                                      this.state.localizationPreferences
                                        .countryId)
                                ) || null
                              }
                              onChange={(event, newValue) => {
                                this.setState({
                                  countryId: newValue?.id || "",
                                });
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  variant="filled"
                                  size="small"
                                  className="filter_input1"
                                />
                              )}
                            />
                          )}
                          {!this.state.edit && (
                            <span className={`formlabel-input`}>
                              {this.state.localizationPreferences.countryName}
                            </span>
                          )}
                        </div>
                        <div className="col-12 ps-0 mt-2 pb-3">
                          <label className="formlabel-style1 d-block">
                            Address
                          </label>
                          {!this.state.edit && (
                            <span className={`formlabel-input`}>
                              {
                                this.state.localizationPreferences
                                  .addressDetails
                              }
                            </span>
                          )}
                          {this.state.edit && (
                            <TextField
                              value={this.state.Address}
                              // value={this.state.Address || this.state.localizationPreferences.addressDetails}
                              multiline
                              fullWidth
                              inputProps={{ maxLength: 255 }}
                              rows={3}
                              variant="outlined"
                              style={{
                                outline: "none",
                                border: "1px solid #d1d1d1;",
                                borderRadius: "0px",
                                fontSize: "13px",
                                color: "#342E37",
                              }}
                              className="mt-2 inputglobal"
                              InputProps={{
                                style: {
                                  borderRadius: 0, // Sharp edges
                                  // Custom border
                                  fontSize: "13px",
                                  color: "#342E37",
                                  outline: "none",
                                },
                                disableUnderline: true,
                              }}
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  "& fieldset": {
                                    borderColor: "#d1d1d1",
                                  },
                                  "&:hover fieldset": {
                                    borderColor: "#d1d1d1",
                                  },
                                  "&.Mui-focused fieldset": {
                                    borderColor: "#d1d1d1",
                                    boxShadow: "none",
                                  },
                                },
                              }}
                              onChange={(e) =>
                                this.setState({ Address: e.target.value })
                              }
                            />
                          )}
                        </div>
                      </div>
                    </div>
                    <hr className="hrproducts mt-2" />
                  </div>
                  <div className="row ps-3 mt-2">
                    <div className="col-12 col-md-12 col-sm-12 col-lg-4">
                      <h3 className="licenseheader">Company logo</h3>
                    </div>
                    {!this.state.edit && (
                      <div className="col-12 col-md-12 col-sm-12 col-lg-8 col-xl-9 col-xxl-10 pt-0 mb-3">
                        {this.state.tenantLogo?.fileBytes ? (
                          <img
                            src={this.getImageSrcFromBase64(
                              this.state.tenantLogo.fileName,
                              this.state.tenantLogo.fileBytes
                            )}
                            width={"200px"}
                            height={"auto"}
                          />
                        ) : (
                          <span className="formlabel-input">
                            No logo has been uploaded
                          </span>
                        )}
                      </div>
                    )}
                    {this.state.edit && (
                      <div className="col-12 col-md-12 col-sm-12 col-lg-8 pt-0">
                        <div className="row">
                          <div
                            className={`col-12 col-sm-12 col-lg-4 col-xl-4 col-md-4 mt-1`}
                          >
                            <span className="">
                              <div class="Profile-upload">
                                <label for="file-input" className="menu-button">
                                  {this.state.uploadedImage ? (
                                    // <CommonIcon fileName={'UploadFile'} />
                                    <>
                                      <img
                                        src={URL.createObjectURL(
                                          this.state.uploadedImage
                                        )}
                                        width={"200px"}
                                        height={"auto"}
                                        alt="Cropped"
                                      />
                                    </>
                                  ) : (
                                    <CommonIcon
                                      fileName={"SelectUploadFile1"}
                                    />
                                  )}
                                </label>
                                <input
                                  id="file-input"
                                  type="file"
                                  accept=".jpg, .jpeg, .png, .gif"
                                  onChange={this.handleFileChange}
                                  disabled={
                                    this.state.uploadedImage ? true : false
                                  }
                                />
                              </div>
                              {/* {this.state.errorProfiles &&
                                        <div>
                                            <span className="errorText">
                                                Please upload the file.
                                            </span>
                                        </div>
                                    } */}
                              {this.state.logo.map((file, index) => (
                                <div className="mt-2">
                                  <span className="file-name-style" key={index}>
                                    {" "}
                                    {file.fileName}
                                    <span
                                      onClick={() => this.deleteFile(index)}
                                    >
                                      <CommonIcon
                                        fileName={"CloseSmall"}
                                        className="cursor-pointer"
                                      />{" "}
                                    </span>
                                  </span>
                                </div>
                              ))}
                            </span>
                          </div>
                        </div>
                      </div>
                    )}
                    <hr className="hrproducts mt-2" />
                  </div>
                  <div className="row ps-3 mt-2">
                    <div className="col-0 "></div>
                    <div className="col-8 pt-0">
                      <div className="col-12 d-flex align-items-start">
                        <div className="col-6 d-flex">
                          {!this.state.edit && (
                            <button
                              className="btn-fun ps-4 pe-4 fs-7"
                              onClick={this.edit}
                            >
                              Edit
                            </button>
                          )}
                          {this.state.edit && (
                            <button
                              className="btn-cancel btn-filter-action border-none ps-0 ms-0"
                              onClick={this.cancel}
                            >
                              Cancel
                            </button>
                          )}
                          {this.state.edit && (
                            <button
                              className="btn-fun ps-4 pe-4 fs-7"
                              onClick={this.update}
                            >
                              Update
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row w-100 ms-3">
                <div className="col-12 "></div>
              </div>
            </div>
          </div>
        )}
        {this.state.showCropper && (
          <ImageCropper
            uploadedImage={this.state.currentFile}
            onCropped={this.onCrop}
            onClose={() => {
              this.setState({ showCropper: false, currentFile: null });
            }}
          />
        )}
        <Backdrop className="spinner-backdrop" open={this.props.isLoading1}>
          <CircularProgress color="primary" />
        </Backdrop>
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    toggleMenu: () => dispatch(toggleMenu()) || false,
    // sideMenu: () => dispatch(sideMenu()) || false,
    dispatch,
  };
};
function mapStateToProps(state) {
  return {
    getapplication: state.applicationReducer.getapplication,
    getApplicationLicenseStatus:
      state.applicationReducer.getApplicationLicenseStatus,
    getApplicationUsers: state.applicationReducer.getApplicationUsers,
    auditLog: state.applicationReducer.auditLog,
    userRoleAssign: state.applicationReducer.userRoleAssign,
    isLoading: state.commonReducer.isLoading,
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(GlobalSettings)
);
